import { FlexRow } from '@/components/common/Flex';
import { BigHeader, Subheader } from '@/components/common/Typography';
import { Box, Checkbox, Spacer, Text } from '@chakra-ui/react';
import { isString } from '@common/util/types';
import { useState } from 'react';
import { Button } from '../common/Button';
import { FlexCol } from '../common/Flex';
import Markdown from '../common/Markdown';

interface AtomicConsentInput {
    contents: string;
    buttonText: string;
}

interface AtomicConsentViewProps {
    title: React.ReactNode;
    description: string;
    accountHolderContent?: React.ReactNode;
    onSubmit: () => void;
    isLoading: boolean;
    consentInput: AtomicConsentInput;
    isDisabled: boolean;
}

const AtomicConsentView = ({
    title,
    description,
    accountHolderContent,
    onSubmit,
    isLoading,
    isDisabled,
    consentInput,
}: AtomicConsentViewProps) => {
    const [isAgreed, setIsAgreed] = useState(false);

    return (
        <FlexCol flex={1} overflowY="auto" minW={{ base: 'auto', lg: '2xl' }}>
            {isString(title) ? <BigHeader mb={4}>{title}</BigHeader> : title}
            <Text color="textMuted" fontSize="md" mb={8}>
                {description}
            </Text>
            <Subheader mb={4}>
                Please review the account opening terms.
            </Subheader>
            {accountHolderContent && <Box mb={4}>{accountHolderContent}</Box>}
            <FlexCol overflow="auto" p={8} mb={12} bg="gray.100" grow={1}>
                <Markdown content={consentInput.contents} />
            </FlexCol>
            <FlexRow justifyContent="space-between" align="center" grow={0}>
                <Spacer />
                <Checkbox
                    size="lg"
                    isChecked={isAgreed}
                    onChange={() => setIsAgreed(!isAgreed)}
                    mr={12}
                >
                    <Text ml={2} fontSize="md">
                        I acknowledge and agree to these terms
                    </Text>
                </Checkbox>
                <Button
                    onClick={onSubmit}
                    onClickEvent="Atomic Consent Button Clicked"
                    isLoading={isLoading}
                    disabled={!isAgreed || isDisabled}
                >
                    {consentInput.buttonText}
                </Button>
            </FlexRow>
        </FlexCol>
    );
};

export default AtomicConsentView;
